import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddPlanReviewFeedbackMutationVariables = Types.Exact<{
  input: Types.Plan_Review_Feedback_Insert_Input;
}>;


export type AddPlanReviewFeedbackMutation = { __typename?: 'mutation_root', insert_plan_review_feedback_one?: { __typename?: 'plan_review_feedback', id: any, job_id: any, finding_id: any, user_id: string, decision: string, error_attribution?: string | null, reason?: string | null, comment?: string | null, created_at: any, updated_at: any } | null };


export const AddPlanReviewFeedbackDocument = gql`
    mutation addPlanReviewFeedback($input: plan_review_feedback_insert_input!) {
  insert_plan_review_feedback_one(object: $input) {
    id
    job_id
    finding_id
    user_id
    decision
    error_attribution
    reason
    comment
    created_at
    updated_at
  }
}
    `;
export type AddPlanReviewFeedbackMutationFn = Apollo.MutationFunction<AddPlanReviewFeedbackMutation, AddPlanReviewFeedbackMutationVariables>;

/**
 * __useAddPlanReviewFeedbackMutation__
 *
 * To run a mutation, you first call `useAddPlanReviewFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlanReviewFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlanReviewFeedbackMutation, { data, loading, error }] = useAddPlanReviewFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPlanReviewFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddPlanReviewFeedbackMutation, AddPlanReviewFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlanReviewFeedbackMutation, AddPlanReviewFeedbackMutationVariables>(AddPlanReviewFeedbackDocument, options);
      }
export type AddPlanReviewFeedbackMutationHookResult = ReturnType<typeof useAddPlanReviewFeedbackMutation>;
export type AddPlanReviewFeedbackMutationResult = Apollo.MutationResult<AddPlanReviewFeedbackMutation>;
export type AddPlanReviewFeedbackMutationOptions = Apollo.BaseMutationOptions<AddPlanReviewFeedbackMutation, AddPlanReviewFeedbackMutationVariables>;